import { FilterPipe } from './filter.pipe';
import { SafePipe } from './safe.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPipe } from './search.pipe';

@NgModule({
  declarations: [SafePipe, FilterPipe, SearchPipe],
  imports: [CommonModule],
  exports: [SafePipe, FilterPipe, SearchPipe]
})
export class PipeModule {}
